//      
import { getRect,           } from 'css-box-model';
                                              
import { subtract, negate } from './position';
                                         

export default (viewport          , newScroll          )           => {
  const diff           = subtract(newScroll, viewport.scroll.initial);
  const displacement           = negate(diff);

  // We need to update the frame so that it is always a live value
  // The top / left of the frame should always match the newScroll position
  const frame       = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width,
  });

  const updated           = {
    frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement,
      },
    },
  };

  return updated;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/scroll-viewport.js